// extracted by mini-css-extract-plugin
export default {"textEditor-content":"TextEditot_textEditor-content__rrNyJ","label":"TextEditot_label__ZS4NM","right":"TextEditot_right__eSZ05","error":"TextEditot_error__pq7a5"};